import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Btn } from "@/components/site/Buttons";

export default function ProtectedRoute({ children }) {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-vs-bg">
        <div className="w-10 h-10 border-4 border-vs-orange border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  if (user.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-vs-bg px-5 text-center">
        <div className="bg-white rounded-3xl p-10 max-w-md">
          <h1 className="text-2xl font-extrabold mb-2">Accesso negato</h1>
          <p className="text-vs-text/70 mb-6">L'account <strong>{user.email}</strong> non è autorizzato ad accedere all'area riservata.</p>
          <Btn variant="secondary" onClick={logout}>Esci</Btn>
        </div>
      </div>
    );
  }

  return children;
}
